import { useMutation } from '@apollo/client';
import { sendInviteProgressGql } from './gql';

const ALLOWED_SUBMIT_STATUSES = new Set(['accepted', 'declined', 'paymentPending']);

const normalizeSubmitStatus = (status) => (
  ALLOWED_SUBMIT_STATUSES.has(status) ? status : 'accepted'
);

export default function useSendInviteProgress() {
  const [sendInviteProgress] = useMutation(sendInviteProgressGql);

  return (inviteCode, payload) => {
    if (!inviteCode || !payload?.type) return;

    const normalizedPayload = payload.type === 'submit'
      ? { ...payload, status: normalizeSubmitStatus(payload.status) }
      : payload;

    sendInviteProgress({
      variables: {
        inviteCode,
        input: normalizedPayload,
      },
    }).catch((error) => {
      // Progress telemetry must never affect the RSVP flow.
      // eslint-disable-next-line no-console
      console.warn('Invite progress tracking failed', {
        inviteCode,
        payload: normalizedPayload,
        error,
      });
    });
  };
}
